export default __webpack_public_path__ + "static/eclipse_hero_background-cbb73446980d236b1c6e740cec4db00b.svg";